import { useTranslation } from "react-i18next";

/**
 * Composant pour un input select dans un formulaire
 * @param {object} item - objet contenant les données du formulaire
 * @param {function} register - fonction register de React Hook Form
 */

export default function Select({ item, register}) {
  const {t} = useTranslation();

  return (
    <select
      multiple={item.multipleSelected}
      id={item.id}
      {...register(item.id)}
      onChange={item.change !== false && item.change}
      defaultValue={
        Array.isArray(item.value)
          ? item.value
          : item.value && item.value
      }
    >
      {item.values &&
        item.values.map((value) => {
          return (
            <option
              key={value.value}
              value={value.value}
            >
              {t(value.label)}
            </option>
          );
        })}
    </select>
  );
}
